import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import {
	getPendingOpportunityUpdate,
	getPendingOpportunityCreate,
} from 'src/redux/opportunities/opportunity.selector';
export const OPPORTUNITIES_PATH = 'v2/opportunities';
export const GET_OPPORTUNITIES = 'GET_OPPORTUNITIES/TEAM/@WISELY/WEB';
export const FETCH_OPPORTUNITIES_SUCCEEDED = 'FETCH_OPPORTUNITIES_SUCCEEDED/TEAM/@WISELY/WEB';
export const FETCH_OPPORTUNITIES_FAILED = 'FETCH_OPPORTUNITIES_FAILED/TEAM/@WISELY/WEB';

/* Get Opportunities */
export const getOpportunities = () => ({
	type: GET_OPPORTUNITIES,
});

export const fetchOpportunitiesSucceeded = payload => ({
	type: FETCH_OPPORTUNITIES_SUCCEEDED,
	payload,
});

export const fetchOpportunitiesFailed = payload => ({
	type: FETCH_OPPORTUNITIES_FAILED,
	payload,
});

export const fetchOpportunities = params => {
	return dispatch => {
		dispatch(getOpportunities());
		const path = OPPORTUNITIES_PATH;

		return getHandler(path, params)
			.then(json => dispatch(fetchOpportunitiesSucceeded(json)))
			.catch(error => {
				console.error('fetchOpportunities error', error);
				dispatch(fetchOpportunitiesFailed(error));
			});
	};
};

/* Update Opportunities */
export const UPDATE_OPPORTUNITY = 'UPDATE_OPPORTUNITY/OPPORTUNITIES/@WISELY/WEB';
export const UPDATE_OPPORTUNITY_SUCCEEDED =
	'UPDATE_OPPORTUNITY_SUCCEEDED/OPPORTUNITIES/@WISELY/WEB';
export const UPDATE_OPPORTUNITY_FAILED = 'UPDATE_OPPORTUNITY_FAILED/OPPORTUNITIES/@WISELY/WEB';

export const updateOpportunity = () => ({
	type: UPDATE_OPPORTUNITY,
});

export const requestUpdateOpportunityFailed = payload => ({
	type: UPDATE_OPPORTUNITY_FAILED,
	payload,
});

export const requestUpdateOpportunitySucceeded = payload => ({
	type: UPDATE_OPPORTUNITY_SUCCEEDED,
	payload,
});

export const requestUpdateOpportunity = (id, body) => {
	return (dispatch, getState) => {
		if (getPendingOpportunityUpdate(getState())) {
			return;
		}

		dispatch(updateOpportunity());
		const path = `${OPPORTUNITIES_PATH}/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateOpportunitySucceeded(json)))
			.catch(error => {
				console.error('requestUpdateOpportunity error', error);
				dispatch(requestUpdateOpportunityFailed(error));
			});
	};
};

/* Create Opportunities */
export const CREATE_OPPORTUNITY = 'CREATE_OPPORTUNITY/OPPORTUNITIES/@WISELY/WEB';
export const CREATE_OPPORTUNITY_SUCCEEDED =
	'CREATE_OPPORTUNITY_SUCCEEDED/OPPORTUNITIES/@WISELY/WEB';
export const CREATE_OPPORTUNITY_FAILED = 'CREATE_OPPORTUNITY_FAILED/OPPORTUNITY/@WISELY/WEB';

export const createOpportunity = () => ({
	type: CREATE_OPPORTUNITY,
});

export const requestCreateOpportunityFailed = payload => ({
	type: CREATE_OPPORTUNITY_FAILED,
	payload,
});

export const requestCreateOpportunitySucceeded = payload => ({
	type: CREATE_OPPORTUNITY_SUCCEEDED,
	payload,
});

export const requestCreateOpportunity = body => {
	return (dispatch, getState) => {
		if (getPendingOpportunityCreate(getState())) {
			return;
		}

		dispatch(createOpportunity());

		return postHandler(OPPORTUNITIES_PATH, JSON.stringify(body))
			.then(json => dispatch(requestCreateOpportunitySucceeded(json)))
			.catch(error => {
				console.error('requestCreateOpportunity error', error);
				dispatch(requestCreateOpportunityFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/opportunities/opportunity.action.js